import React from 'react'
import {Button} from '@skillrecordings/react'
import {useCopyToClipboard} from 'react-use'
import toast from 'react-hot-toast'

const CopyInviteLink: React.FC<
  React.PropsWithChildren<{
    bulkCouponId: string
    disabled?: boolean
    className?: string
    productSlug?: string
    productActive?: boolean
  }>
> = ({
  bulkCouponId,
  disabled = false,
  className = '',
  productSlug,
  productActive = true,
}) => {
  const [_, setCopied] = useCopyToClipboard()

  let inviteLink: string

  inviteLink = `${process.env.NEXT_PUBLIC_URL}?code=${bulkCouponId}`

  return (
    <div data-copy-invite-link="" className={className}>
      <label htmlFor="inviteLink">Invite link</label>
      <div>
        <input
          readOnly
          disabled={disabled}
          id="inviteLink"
          onClick={(e) => {
            if (disabled) return
            e.currentTarget.select()
          }}
          value={
            disabled ? 'Buy more seats to view your invite link' : inviteLink
          }
        />
        <Button
          type="button"
          onClick={() => {
            setCopied(inviteLink)
            toast.success('Copied')
          }}
          disabled={disabled}
        >
          Copy Link
        </Button>
      </div>
    </div>
  )
}

export default CopyInviteLink
